import { defineStore } from "pinia";

export const useSurveyDataStore = defineStore("surveyData", {
    state: () => ({
        selectedType: "",
        validTypes: [],
        isSessionActive: false,
    }),

    getters: {
        isValidType: (state) => (type) => {
            return state.validTypes.includes(String(type).toLowerCase())
        }
    },

    actions: {
        setValidTypes(types = []) {
            const unique = Array.from(
                new Set((types ?? []).map((t) => String(t).toLowerCase()))
            );
            this.validTypes = unique;
            if (this.selectedType && !this.isValid(this.selectedType))
                this.clearType();
        },

        setType(type) {
            const lowerType = String(type).toLowerCase();
            if (this.validTypes.includes(lowerType)) {
                this.selectedType = lowerType;
                this.isSessionActive = true;
                sessionStorage.setItem("survey_data_selected_type", lowerType);
                sessionStorage.setItem("survey_data_session_active", "true");
            }
        },

        clearType() {
            this.selectedType = "";
            this.isSessionActive = false;
            sessionStorage.removeItem("survey_data_selected_type");
            sessionStorage.removeItem("survey_data_session_active");
        },

        clearSession() {
            this.clearType();
        },

        isValid(type) {
            return this.validTypes.includes(String(type).toLowerCase());
        },

        restoreFromStorage() {
            const stored = sessionStorage.getItem("survey_data_selected_type");
            const sessionActive = sessionStorage.getItem(
                "survey_data_session_active"
            );
            if (stored && sessionActive === "true") {
                this.selectedType = stored;
                this.isSessionActive = true;
            }
        },

        shouldAutoRedirect() {
            return (
                this.isSessionActive &&
                this.selectedType &&
                this.isValid(this.selectedType)
            );
        },
    },
});
